import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";
import GitHubStarsLink from "../components/GitHubStarsLink";

export default function AppShell({ children }) {
  const { user, logout } = useAuth();
  const location = useLocation();

  const nav = [
    { to: "/", label: "Home" },
    { to: "/dashboard", label: "Ideas" },
    { to: "/new", label: "New idea" },
    { to: "/profile", label: "Profile" },
  ];

  return (
    <div className="min-h-screen min-h-dvh bg-white flex flex-col">
      <header className="sticky top-0 z-20 bg-white/85 backdrop-blur-md border-b border-zinc-200">
        <div className="max-w-7xl mx-auto px-6 md:px-8 h-14 flex items-center justify-between">
          <div className="flex items-center gap-6">
            <Link
              to="/dashboard"
              className="flex items-center gap-2"
              data-testid="shell-brand"
            >
              <div className="w-5 h-5 bg-zinc-950 rounded-sm flex items-center justify-center">
                <span className="text-white font-mono text-[9px] font-bold">
                  KS
                </span>
              </div>
              <div className="leading-none">
                <div className="font-display font-semibold tracking-tight">
                  Killswitch
                </div>
                <div className="text-[10px] font-mono uppercase tracking-[0.18em] text-zinc-500">
                  by Softwired
                </div>
              </div>
            </Link>
            <nav className="hidden md:flex items-center gap-1">
              {nav.map((n) => {
                const active =
                  location.pathname === n.to ||
                  (n.to === "/dashboard" && location.pathname === "/dashboard");
                return (
                  <Link
                    key={n.to}
                    to={n.to}
                    data-testid={`nav-${n.label.toLowerCase().replace(/\s/g, "-")}`}
                    className={`px-3 py-1.5 rounded-sm text-sm font-medium transition-colors ${active ? "bg-zinc-100 text-zinc-950" : "text-zinc-600 hover:text-zinc-950 hover:bg-zinc-50"}`}
                  >
                    {n.label}
                  </Link>
                );
              })}
            </nav>
          </div>
          <div className="flex items-center gap-3">
            <GitHubStarsLink
              className="hidden lg:flex items-center gap-2 text-[15px] font-medium tracking-tight text-zinc-600 hover:text-zinc-950 transition-colors"
            />
            {user && (
              <div
                className="hidden sm:flex items-center gap-2 pr-2 text-sm text-zinc-600"
                data-testid="user-chip"
              >
                {user.picture ? (
                  <img
                    alt={user.name}
                    src={user.picture}
                    className="w-6 h-6 rounded-full border border-zinc-200"
                  />
                ) : (
                  <div className="w-6 h-6 rounded-full bg-zinc-100 border border-zinc-200" />
                )}
                <span className="max-w-[140px] truncate">{user.name}</span>
              </div>
            )}
            <button
              data-testid="logout-btn"
              className="btn btn-ghost text-xs"
              onClick={logout}
            >
              Sign out
            </button>
          </div>
        </div>
      </header>
      <main className="max-w-7xl w-full mx-auto px-6 md:px-8 py-10 flex-1 flex flex-col">
        {children}
      </main>
      <footer className="border-t border-zinc-200">
        <div className="max-w-7xl mx-auto px-6 md:px-8 py-4 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between text-[10px] text-zinc-500 font-mono uppercase tracking-[0.18em]">
          <span>Killswitch by Softwired</span>
          <div className="flex items-center gap-4">
            <a
              href="https://softwired.in"
              target="_blank"
              rel="noreferrer"
              className="hover:text-zinc-950 transition-colors"
            >
              softwired.in
            </a>
            <a
              href="mailto:admin@softwired.in"
              className="hover:text-zinc-950 transition-colors"
            >
              admin@softwired.in
            </a>
            <Link
              to="/contact"
              className="hover:text-zinc-950 transition-colors"
            >
              Contact / Feedback
            </Link>
          </div>
        </div>
      </footer>
    </div>
  );
}
